/* eslint-disable no-console */
import {Flex, Table} from 'antd';
import React, {useState} from 'react';

import {tableColumnMap} from '../../pages/OCR/utils/commonFunction';
import {AllCap} from '../../utils/FormUtils/FirstCap';

const CustomTable: React.FC<{data: any}> = ({data}) => {
  const [page, setPage] = useState(1);
  const pageSize = 10;

  const column = [
    {
      title: 'S. No.',
      dataIndex: 'srNo',
      render: (id: any, record: any, index: any) => {
        return (page - 1) * pageSize + ++index;
      }
    },
    ...tableColumnMap(data.value)
  ];

  return (
    <Flex
      vertical={true}
      align="center"
      justify="center"
      gap={10}
      style={{width: '100%'}}
    >
      <div style={{fontWeight: 'bold'}}>{AllCap(data?.name)}</div>
      <Table
        scroll={{x: 'scroll'}}
        columns={column}
        style={{width: '100%'}}
        dataSource={data?.value ?? []}
        rowKey={'dataIndex'}
        pagination={{
          pageSize,
          onChange(current) {
            setPage(current);
          }
        }}
      />
    </Flex>
  );
};

export default CustomTable;
